import AddEditPart, { Part } from '../../AddEditPart'
import { PartFormState } from '../../PartForm'
import useUpdatePartHandler from '../../../effects/update-part'
import { heapEvent } from '@equipmentshare/heaper'

export type EditPartModalProps = {
  onCancel: () => void,
	onMerge: ( part: Part ) => void,
	onSuccess: () => void,
	formData: PartFormState,
  part?: Part,
}

export default function EditPartModal( { formData, onCancel, onSuccess, onMerge, part }: EditPartModalProps ) {
	const updatePart = useUpdatePartHandler()

	const handleSubmit = async( partArgs: any ) => {
		heapEvent( 'Inventory - Edit Part Modal - Click - Submit', {} )
		return await updatePart( partArgs )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Part Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<AddEditPart
			canMerge
			onMerge={onMerge}
			onCancel={handleCancel}
			onSuccess={onSuccess}
			onSubmit={handleSubmit}
			part={part}
			formData={formData}
		/>
	)
}
